
import { Activite, User } from "@/models";
import { Component, Prop, Vue } from "vue-property-decorator";

import tag from "@/components/tags/Tag.vue";
import cta from "@/components/buttons/Button.vue";
import dayjs from "dayjs";
import { IsStarted } from "@/helpers";
import { login } from "@/store";

@Component({
  methods: {
    IsStarted,
  },
  components: { tag, cta },
})
/** Quick-action bottom-sheet for an activity (sign-up shortcuts, links to detail/verification). */
export default class optionActivite extends Vue {
  @Prop({ required: true }) value!: boolean;
  @Prop({ required: true }) data!: Activite | null;

  private closeOption(): void {
    this.$emit("close");
  }

  /** Navigates to the full activity detail/edit page. */
  private openModification(): void {
    this.$router.push(`/activite/${this.data?.id}`);
  }

  /** Navigates to guided verification, scoped to this activity. */
  private openVerification(activiteId: string): void {
    this.$router.push({
      name: "VerificationAssisteeWithActivite",
      params: { activite: activiteId },
    });
  }

  private date(date: string, format = "DD/MM/YYYY"): string {
    return dayjs(date).format(format);
  }

  get context(): User | null {
    return login.getContext;
  }
}
